import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { ViewComponentsDialogComponent } from './view-components-dialog.component'
import { MbI18nModule } from '../../../../translations/mb-i18n.module'
import { SafeHtmlModule } from '../../../../cms/pipes/sanitize-html/safe-html.module'

@NgModule({
  declarations: [ViewComponentsDialogComponent],
    imports: [
        CommonModule,
        NgbModule,
        MbI18nModule,
        SafeHtmlModule
    ]
})
export class ViewComponentsDialogModule { }
